import { getEnvConfig } from '@app/env.config';

export const BENNIE_ORIGINATOR = 'bennie-web';
export const ORIGINATOR_HEADER = 'x-bennie-originator';
export const ORIGINATOR_VERSION_HEADER = 'x-bennie-originator-version';

export function getOriginatorHeaders() {
  const version = getEnvConfig()?.VERSION?.trim();
  const headers = {
    [ORIGINATOR_HEADER]: BENNIE_ORIGINATOR,
  };

  if (version) {
    headers[ORIGINATOR_VERSION_HEADER] = version;
  }

  return headers;
}
